import PadraoService from '@/modules/services/padrao.service'
import * as msg from '../mensagens/produto.msg'

class ProdutoService extends PadraoService {
  constructor() {
    // Rota, Biblioteca de mensagens
    super('produtos', msg)
  }
}

export default new ProdutoService()
